import { render, staticRenderFns } from "./DuplicateInvoice.vue?vue&type=template&id=58fc2884&scoped=true&"
import script from "./DuplicateInvoice.vue?vue&type=script&lang=js&"
export * from "./DuplicateInvoice.vue?vue&type=script&lang=js&"
import style0 from "./DuplicateInvoice.vue?vue&type=style&index=0&id=58fc2884&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58fc2884",
  null
  
)

export default component.exports